module.exports = __webpack_public_path__ + "img/loader.6504ae74.gif";